import { Config } from '@/state/session';
import NavigationDrawerItem from '@/components/Header/NavigationDrawer/NavigationDrawerItem';
import NavigationDrawerItemGroup from '@/components/Header/NavigationDrawer/NavigationDrawerItemGroup';
import { useAccidentHistoryDrawer } from '@/features/AccidentHistory/components/AccidentHistoryDrawer';
import { useIncidentHistoryDrawer } from '@/features/IncidentHistory/components/IncidentHistoryDrawer';
import { useIssueHistoryDrawer } from '@/features/IssueHistory/components/IssueHistoryDrawer';
import { useSummaryHistoryDrawer } from '@/features/SummaryHistory/components/SummaryHistoryDrawer';

export const createServiceIssuePermissions: Record<string, keyof Config['auth']> = {
  accidents: 'allowCreateAccidentIssue',
  incidents: 'allowCreateIncidentIssue',
  dispatchIssues: 'allowCreateDispatchIssue',
  dispatchSummaries: 'allowCreateDispatchSummary',
};

const CreateServiceIssuesGroup = (): JSX.Element => {
  const setAccidentHistoryDrawer = useAccidentHistoryDrawer(({ setState }) => setState);
  const setIncidentHistoryDrawer = useIncidentHistoryDrawer(({ setState }) => setState);
  const setSummaryHistoryDrawer = useSummaryHistoryDrawer(({ setState }) => setState);
  const setIssueHistoryDrawer = useIssueHistoryDrawer(({ setState }) => setState);
  return (
    <NavigationDrawerItemGroup title="New Service Issue" permissions={Object.values(createServiceIssuePermissions)}>
      <NavigationDrawerItem
        name="Create Accident"
        icon={<i className="sv sv-ambulance" />}
        onClick={() =>
          setAccidentHistoryDrawer((current) => ({
            ...current,
            show: true,
            data: {},
          }))
        }
        restricted
        permissions={[createServiceIssuePermissions.accidents]}
      />
      <NavigationDrawerItem
        name="Create Incident"
        icon={<i className="sv sv-shield-alert" />}
        onClick={() =>
          setIncidentHistoryDrawer((current) => ({
            ...current,
            show: true,
            data: {},
          }))
        }
        restricted
        permissions={[createServiceIssuePermissions.incidents]}
      />
      <NavigationDrawerItem
        name="Create Dispatch Issue"
        icon={<i className="sv sv-headset" />}
        onClick={() =>
          setIssueHistoryDrawer((current) => ({
            ...current,
            show: true,
            data: {},
          }))
        }
        restricted
        permissions={[createServiceIssuePermissions.dispatchIssues]}
      />
      <NavigationDrawerItem
        name="Create Dispatch Summary"
        icon={<i className="sv sv-bookmark" />}
        onClick={() =>
          setSummaryHistoryDrawer((current) => ({
            ...current,
            show: true,
            data: {},
          }))
        }
        restricted
        permissions={[createServiceIssuePermissions.dispatchSummaries]}
      />
    </NavigationDrawerItemGroup>
  );
};

export default CreateServiceIssuesGroup;
